__turbopack_context__.v({
  "title": "Performers-module-scss-module__00igCq__title",
  "toggleButton": "Performers-module-scss-module__00igCq__toggleButton",
});
